<div
  class="relative mx-auto w-full max-w-[480px] bg-cover bg-center aspect-[0.89] max-md:flex max-md:flex-col max-md:aspect-auto sm:max-w-full sm:aspect-[4] md:aspect-auto md:h-[424px]">
  <!-- <app-loader *ngIf="isLoading"></app-loader> -->

  <!-- Actual Banner Content -->
  <div *ngIf="!isLoading"
    class="banner-container overflow-hidden max-md:relative max-md:order-2 max-md:h-[280px] max-md:w-full max-md:flex-shrink-0 md:absolute md:inset-0 md:h-full md:w-full object-cover object-center"
    [class.grabbing]="isDragging" (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp($event)" (mouseleave)="onMouseLeave($event)" (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
    <ng-container *ngFor="let banner of centerBanners; let i = index">
      <div class="absolute inset-0 transition-opacity duration-500" [class.opacity-100]="i === currentIndex"
        [class.opacity-0]="i !== currentIndex">
        <img [src]="banner" class="h-full min-h-[280px] w-full object-cover object-center md:h-[424px]"
          [alt]="'Slide ' + (i + 1)" />
      </div>
    </ng-container>

    <!-- <div class="absolute inset-0 pointer-events-none">
      <button
        (click)="previousSlide()"
        class="absolute top-1/2 left-2 -translate-y-1/2 text-white text-4xl w-10 h-10 bg-black/30 hover:bg-black/80 rounded-full text-center leading-[2.5rem] cursor-pointer z-10 transition-colors pointer-events-auto"
        *ngIf="centerBanners.length > 1"
      >
        ‹
      </button>
      
      <button
        (click)="nextSlide()"
        class="absolute top-1/2 right-2 -translate-y-1/2 text-white text-4xl w-10 h-10 bg-black/30 hover:bg-black/80 rounded-full text-center leading-[2.5rem] cursor-pointer z-10 transition-colors pointer-events-auto"
        *ngIf="centerBanners.length > 1"
      >
        ›
      </button>
    </div> -->

    <!-- Mobile hero T-frame (white), per design -->
    <div class="pointer-events-none absolute inset-0 z-[15] max-md:block md:hidden" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="178" viewBox="0 0 100 178" fill="none"
        class="t-image">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M64 0H0V56V178H64V56H100V0H64Z" fill="white" />
      </svg>
      <div class="horizontal-line"></div>
      <div class="vertical-line"></div>
      <div class="bottom-horizontal-line"></div>
      <div class="bottom-vertical-line"></div>
    </div>

    <!-- Indicators -->
    <div class="absolute bottom-4 left-0 right-0 flex justify-center mb-8 z-10">
      <ol class="carousel-indicators-container flex items-center gap-2 px-2">
        <li *ngFor="let banner of centerBanners; let i = index">
          <button (click)="goToSlideByIndex(i)" class="carousel-dot cursor-pointer transition-all duration-300"
            [class.carousel-dot-active]="i === currentIndex"></button>
        </li>
      </ol>
    </div>
  </div>

  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="178" viewBox="0 0 100 178" fill="none"
    class="t-image max-md:hidden">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M64 0H0V56V178H64V56H100V0H64Z" fill="white" />
  </svg>
  <div class="horizontal-line max-md:hidden"></div>
  <div class="vertical-line max-md:hidden"></div>
  <div class="bottom-horizontal-line max-md:hidden"></div>
  <div class="bottom-vertical-line max-md:hidden"></div>
  <article class="relative z-20 flex w-full items-start max-md:order-1 max-md:mt-0 max-md:px-4 max-md:py-2 md:mt-0">
    <section
      class="relative flex w-full min-w-0 max-w-full flex-col items-center px-0 pb-0 pt-0 max-md:mt-0 md:mt-14 md:px-16 md:pb-80">
      <!-- Search Bar and Popups Relative Wrapper -->
      <div class="relative w-full min-w-0 max-w-full md:max-w-[650px] md:mt-[-25px] lg:mt-[-20px]">
        <section
          class="flex w-full min-w-0 max-w-full items-center justify-between gap-2 rounded-lg border bg-white px-3 py-2 md:gap-4 md:px-4 md:py-2">
        <!-- Left: Search Field -->
        <div class="flex min-w-0 flex-1 items-center gap-2">
          <img [src]="searchIconUrl" class="w-6 h-6 object-contain hidden md:inline cursor-pointer"
            (click)="onSearchTrigger()" alt="Search icon" />
          <!-- <input  placeholder="Search Part name, Vehicle Model, Scrap, etc." [(ngModel)]="searchValue" (keydown)="advanceSearch()"
            class="w-full font-medium text-neutral-700 focus:outline-none focus:ring-0 focus:border-transparent"
            (focus)="onFocus()" (blur)="onBlur()" /> -->

          <input #searchInput [placeholder]="getCurrentPlaceholder()" [(ngModel)]="searchValue"
            class="w-full font-medium text-neutral-700 focus:outline-none focus:ring-0 focus:border-transparent animated-placeholder overflow-hidden text-ellipsis whitespace-nowrap"
            (input)="onInputChange()" (keydown.enter)="onEnterKey($event)" (keyup.enter)="onEnterKey($event)"
            (focus)="onFocus()" (blur)="onBlur()" />

          <button type="button"
            class="relative inline-flex h-10 w-10 shrink-0 items-center justify-center transition focus:outline-none focus:ring-2 focus:ring-blue-500/40 disabled:cursor-not-allowed disabled:opacity-50"
            [class.bg-red-50]="isListening" [class.text-red-600]="isListening" [class.animate-pulse]="isListening"
            [class.text-slate-600]="!isListening" [attr.aria-label]="
              isListening ? 'Listening...' : 'Start voice search'
            " [attr.title]="
              isVoiceSupported
                ? isListening
                  ? 'Listening...'
                  : 'Use voice search'
                : 'Voice search not supported'
            " [disabled]="!isVoiceSupported" (click)="onVoiceSearchClick($event)">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M12 15.5C9.79086 15.5 8 13.7091 8 11.5V7.5C8 5.29086 9.79086 3.5 12 3.5C14.2091 3.5 16 5.29086 16 7.5V11.5C16 13.7091 14.2091 15.5 12 15.5Z"
                stroke="currentColor" stroke-width="1.6" />
              <path d="M5.5 11.5C5.5 15.0899 8.41015 18 12 18C15.5899 18 18.5 15.0899 18.5 11.5" stroke="currentColor"
                stroke-width="1.6" stroke-linecap="round" />
              <path d="M12 18V21" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <!-- (blur)="onBlur()" -->
        <!--  -->
        <!-- Right: Button -->
        <div class="flex items-center gap-2" (click)="navigateBy()">
          <!-- <img [src]="actionIconUrl" class="w-6 h-6 object-contain cursor-pointer" alt="Action icon" /> -->
          <button class="flex items-center gap-1 px-4 py-2 rounded-lg bg-blue-950 text-white hover:bg-blue-800">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 object-contain cursor-pointer" (click)="navigateBy()">
              <path
                d="M14.6569 14.6569C17.781 11.5327 17.781 6.46734 14.6569 3.34315C11.5327 0.218952 6.46734 0.218952 3.34315 3.34315C0.218952 6.46734 0.218952 11.5327 3.34315 14.6569C6.46734 17.781 11.5327 17.781 14.6569 14.6569ZM14.6569 14.6569L19 19"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <!-- <img src="/src/assets/Icon.png" class="w-6 h-6 object-contain block md:hidden cursor-pointer" alt="Search icon" /> -->

            <!-- This will be visible on md (tablet) and up -->
            <span class="hidden md:inline">Search</span>
          </button>
        </div>
      </section>
      <section *ngIf="showPopup && searchValue.length === 0"
        (mousedown)="$event.preventDefault()"
        class="slide-top-bottom absolute top-full left-0 right-0 mt-2 overflow-y-auto max-h-[70vh] p-3 bg-white rounded-xl shadow-lg border border-gray-100 w-full z-50">
        <!-- Your Vehicles Section -->
        <!-- <section *ngIf="guideSearchData?.your_vehicles.length > 0" class="flex flex-col {{ marginTop }} w-full {{
              minHeight
            }} max-md:max-w-full cursor-pointer">

          <header class="flex flex-wrap gap-10 justify-between items-center w-full cursor-pointer {{
                headerFontWeight
              }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Your Vehicles
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer" (click)="seeMoregotoProductList('your_vehicles')">
              See more
            </button>
          </header>
          <ul class="flex flex-wrap gap-6 items-center self-start cursor-pointer mt-2 {{
                itemsTextSize
              }} {{ itemsFontWeight }} leading-none text-black {{
                itemsWhitespace
              }}">
            <li *ngFor="let item of guideSearchData?.your_vehicles" class="flex gap-2 items-center self-stretch cursor-pointer {{
                  itemPadding
                }} my-auto {{ itemBorder }}">
              <img [src]="item?.image ? item?.image : defaultImage" [alt]="item?.model" [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{ item?.make }},{{ item?.model }}</span>
            </li>
          </ul>
        </section> -->

        <!-- Popular Brands Section -->
        <!-- <section *ngIf="guideSearchData?.popular_brands.length > 0" class="flex p-1 max-md:border-t max-md:border-gray-200 flex-col {{ marginTop }} w-full {{
              minHeight
            }} max-md:max-w-full">
          <header class="flex flex-wrap gap-10 justify-between items-center w-full {{
                headerFontWeight
              }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Popular Brands
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer" (click)="seeMoregotoProductList('popular_brands')">
              See more
            </button>
          </header>
          <ul class="flex flex-wrap gap-6 items-center self-start mt-2 {{
                itemsTextSize
              }} {{ itemsFontWeight }} leading-none text-black {{
                itemsWhitespace
              }}">
            <li *ngFor="let item of guideSearchData?.popular_brands"  (click)="gotoProductList(item, 'used part')" class="flex gap-2 items-center self-stretch cursor-pointer {{
                  itemPadding
                }} my-auto {{ itemBorder }}">
              <img [src]="item?.image ? item?.image : defaultImage" [alt]="item?.make" [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{ item?.make }}</span>
            </li>
          </ul>
        </section>   -->

        <!-- Popular Vehicles Section -->
        <!-- <section *ngIf="guideSearchData?.popular_vehicles.length > 0" class="flex max-md:border-t p-1 max-md:border-gray-200 flex-col {{ marginTop }} w-full {{
              minHeight
            }} max-md:max-w-full">
          <header class="flex flex-wrap gap-10 justify-between items-center w-full {{
                headerFontWeight
              }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Popular Vehicles
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer" (click)="seeMoregotoProductList('popular_vehicles')">
              See more
            </button>
          </header>
          <ul class="flex flex-wrap gap-6 items-center self-start mt-2 {{
                itemsTextSize
              }} {{ itemsFontWeight }} leading-none text-black {{
                itemsWhitespace
              }}">
            <li *ngFor="let item of guideSearchData?.popular_vehicles"  (click)="gotoProductList(item, 'used part')" class="flex gap-2 items-center self-stretch cursor-pointer {{
                  itemPadding
                }} my-auto {{ itemBorder }}">
              <img [src]="item?.image ? item?.image : defaultImage" [alt]="item.make" [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{ item.model }}, {{ item.make }}</span>
            </li>
          </ul>
        </section> -->

        <!-- Popular Categories Section -->
        <!-- <section *ngIf="guideSearchData?.popular_categories.length > 0" class="flex max-md:border-t p-1 max-md:border-gray-200 flex-col {{ marginTop }} w-full {{
              minHeight
            }} max-md:max-w-full">
          <header class="flex flex-wrap gap-10 justify-between items-center w-full {{
                headerFontWeight
              }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Popular Categories
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer" (click)="seeMoregotoProductList('popular_categories')">
              See more
            </button>
          </header>
          <ul class="flex flex-wrap gap-6 items-center self-start mt-2 {{
                itemsTextSize
              }} {{ itemsFontWeight }} leading-none text-black {{
                itemsWhitespace
              }}">
            <li *ngFor="let item of guideSearchData?.popular_categories"  (click)="gotoProductList(item, 'used part')" class="flex gap-2 items-center self-stretch cursor-pointer {{
                  itemPadding
                }} my-auto {{ itemBorder }}">
              <img [src]="item?.image ? item?.image : defaultImage" [alt]="item?.category" [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{ item?.category }}</span>
            </li>
          </ul>
        </section> -->

        <!-- Popular Parts Section -->
        <!-- <section *ngIf="guideSearchData?.popular_parts.length > 0" class="flex max-md:border-t p-1 max-md:border-gray-200 flex-col {{ marginTop }} w-full {{
              minHeight
            }} max-md:max-w-full">
          <header class="flex flex-wrap gap-10 mb-2 justify-between items-center w-full {{
                headerFontWeight
              }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Popular Parts
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer" (click)="seeMoregotoProductList('popular_parts')">
              See more
            </button>
          </header>
          <ul
            class="flex flex-wrap gap-6 items-center self-start mt-2text-sm font-medium leading-none text-black whitespace-nowrap">
            <li *ngFor="let item of guideSearchData?.popular_parts"  (click)="gotoProductList(item, 'used part')"
            class="flex gap-2 items-center self-stretch px-2 py-1 my-auto border border-solid border-neutral-300 rounded-[32px]">
              <img [src]="item?.image ? item?.image : defaultImage" [alt]="item?.part_name" [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{ item.part_name | slice:14}}</span>
            </li>
          </ul>
        </section> -->

        <!-- Popular Scrap Section -->
        <section *ngIf="guideSearchData?.popular_scrap.length > 0" class="flex max-md:border-t p-1 max-md:border-gray-200 flex-col {{
            marginTop
          }} w-full {{ minHeight }} max-md:max-w-full">
          <header class="flex flex-wrap gap-10 mb-2 justify-between items-center w-full {{
              headerFontWeight
            }} max-md:max-w-full">
            <h2 class="self-stretch my-auto text-sm leading-none text-zinc-700">
              Popular Scrap
            </h2>
            <button class="self-stretch my-auto text-xs leading-none text-blue-500 cursor-pointer"
              (click)="seeMoregotoProductList('popular_scrap')">
              See more
            </button>
          </header>
          <ul
            class="flex flex-wrap gap-6 items-center self-start mt-2text-sm font-medium leading-none text-black whitespace-nowrap">
            <li *ngFor="let item of guideSearchData?.popular_scrap" (click)="gotoProductList(item, 'Scrap Part')"
              class="flex gap-2 items-center self-stretch px-2 py-1 my-auto border border-solid border-neutral-300 rounded-[32px]">
              <img [src]="item?.image ? item?.image : scrapDefaultImage" [alt]="item?.make"
                [class]="getImageClass(item)" />
              <span class="self-stretch my-auto cursor-pointer">{{
                item?.make
                }}</span>
            </li>
          </ul>
        </section>
      </section>

      <section *ngIf="searchValue.length > 0 && showPopup"
        (mousedown)="$event.preventDefault()"
        class="slide-top-bottom absolute top-full left-0 right-0 mt-2 flex flex-col items-start overflow-y-auto max-h-[70vh] p-3 font-medium bg-white rounded-xl shadow-lg border border-gray-100 w-full z-50">
        <!-- Smart Fill Header and Chips - Only show if smart_fill has data -->
        <header *ngIf="
            advanceSearchData?.smart_fill &&
            advanceSearchData?.smart_fill?.length > 0
          " class="flex flex-wrap gap-2 items-center self-stretch w-full max-md:max-w-full">
          <h2 class="self-stretch my-auto text-xs leading-none text-zinc-700">
            Smart Fill:
          </h2>
          <div *ngFor="let chip of advanceSearchData?.smart_fill"
            class="flex gap-2 items-start self-stretch my-auto text-sm leading-none text-black whitespace-nowrap min-w-20">
            <button (click)="onChipClick(chip)" [class.bg-blue-100]="chip === selectedChip"
              class="gap-1 self-stretch px-3 py-1 bg-zinc-100 hover:bg-zinc-200 rounded-[45px] text-sm leading-none transition-colors">
              {{ chip?.value }}
            </button>
          </div>
        </header>

        <!-- Suggestions List - Only show if suggestions have data -->
        <ul *ngIf="
            advanceSearchData?.suggestions &&
            advanceSearchData?.suggestions?.length > 0
          " class="w-full mt-2 slide-top-bottom">
          <li class="flex gap-2 mt-2 items-center text-sm leading-none text-black"
            *ngFor="let suggestion of advanceSearchData?.suggestions">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/52a7c4266438e8a7e6daadb76f4e7c06e3f00872?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
              class="object-contain shrink-0 self-stretch my-auto w-4 aspect-square" alt="Suggestion icon" />
            <p class="self-stretch my-auto cursor-pointer" (click)="onSuggestionClick(suggestion)">
              <span class="font-bold" *ngIf="suggestion?.make">{{
                suggestion?.make
                }}</span>
              <span class="font-bold" *ngIf="suggestion?.model">,{{ suggestion?.model }}</span>
              <span class="font-bold" *ngIf="suggestion?.year_of_manufacture">,{{ suggestion?.year_of_manufacture
                }}</span>
              <span class="font-bold" *ngIf="suggestion?.variant">
                ,{{ suggestion?.variant }}</span>
            </p>
          </li>
        </ul>

        <!-- No Data Found Message - Show when both arrays are empty -->
        <div *ngIf="
            (!advanceSearchData?.smart_fill ||
              advanceSearchData?.smart_fill?.length === 0) &&
            (!advanceSearchData?.suggestions ||
              advanceSearchData?.suggestions?.length === 0)
          " class="w-full py-4 text-center text-sm text-gray-500">
          No data Found
        </div>
      </section>
      </div>

      <!-- <section *ngIf="searchValue.length > 0 && showPopup"
        class="flex absolute top-14 mt-2 left-1/2 transform -translate-x-1/2 overflow-hidden flex-col items-start p-3 font-medium bg-white rounded-xl shadow-sm max-w-[644px] w-full max-sm:top-[-50px]">
        <header class="flex flex-wrap gap-2 items-center self-stretch w-full max-md:max-w-full">
          <h2 class="self-stretch my-auto text-xs leading-none text-zinc-700">
            Smart Fill :
          </h2>
          <div *ngFor="let chip of advanceSearchData?.smart_fill"
            class="flex gap-2 items-start self-stretch my-auto text-sm leading-none text-black whitespace-nowrap min-w-20">
            <button (click)="onChipClick(chip)" [class.bg-blue-100]="chip === selectedChip"
              class="gap-1 self-stretch px-3 py-1 bg-zinc-100 hover:bg-zinc-200 rounded-[45px] text-sm leading-none transition-colors">
              {{ chip?.value }}
            </button>
          </div>
        </header>

        <ul class="w-full mt-2">
          <li class="flex gap-2 mt-2 items-center text-sm leading-none text-black"
            *ngFor="let suggestion of advanceSearchData?.suggestions">
            <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/52a7c4266438e8a7e6daadb76f4e7c06e3f00872?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7" class="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
              alt="Suggestion icon" />
            <p class="self-stretch my-auto cursor-pointer">
              <span class="font-bold">{{ suggestion?.make }},</span>
               <span class="font-bold">{{ suggestion?.model }},</span>
                <span class="font-bold">{{ suggestion?.year_of_manufacture }},</span>
              {{ suggestion?.variant }}
            </p>
          </li>
        </ul>
      </section> -->
    </section>
  </article>
</div>